$(document).ready(function() {
  /* Remove Text Decoration of Sale Price on Page Load */
  $('.product-page-info__price span:first-child, .footbar-product__price span:first-child').css('text-decoration', 'none');

  // $(function() {
  //   $("#rental").datepicker({
  //     dateFormat: 'yy-mm-dd'
  //   });
  // });
  
  /* Pincode Validation */
  // var closePopup = localStorage.getItem("closePop");
  // if(pincodeValidatorEnable){
  //   var ExistPincode = localStorage.getItem('ExistPincode');
  //   var PinMsg = localStorage.getItem('PinMsg');
  //   if(ExistPincode){
  //     $('.pincode-1').val(ExistPincode);
  //     $('.pin_msg').text(PinMsg).css('color','#000');
  //   }
    
  //   const pin_list_1 = pincodeList_1;
  //   const pin_list_2 = pincodeList_2;  
  //   const pin_list_3 = pincodeList_3;
  //   const pin_list_4 = pincodeList_4; 
    
  //   $('.pin-validate-btn').click(function(i){
  //     var popup_open = $('.popup-pincode').css('display');
  //     if (popup_open == "block"){
  //       var pin_1 = $('.popup-pincode-inner .pincode-1');
  //       var pincode_1 =  pin_1.val();
  //     }else{
  //       var pin_1 = $(this).parent('.pincode-validator').find('input.pincode-1');
  //       var pincode_1 = pin_1.val();
  //     } 
      
  //     if (/^(\d{6})$/.test(pincode_1)) {
  //       if ( $.inArray(pincode_1, pin_list_1) > -1) {
  //         localStorage.setItem('ExistPincode', pincode_1);
  //         localStorage.setItem('storepincode', pincode_1);
  //         $('.pincode-1').attr('placeholder', 'Enter PIN').css('color','#02397f');
  //         if (popup_open == "block"){
  //           setTimeout(function(){$('.popup-pincode').hide();},500);
  //         }
  //         $('.pincode-1').val(pincode_1);
  //         $('.cstm-msg1').show();
  //       }else if ($.inArray(pincode_1, pin_list_2) > -1){
  //         localStorage.setItem('ExistPincode', pincode_1);
  //         localStorage.setItem('storepincode', pincode_1);
  //         $('.pincode-1').attr('placeholder', 'Enter PIN').css('color','#02397f');
  //         if (popup_open == "block"){
  //           setTimeout(function(){$('.popup-pincode').hide();},500);
  //         }
  //         $('.pincode-1').val(pincode_1);
  //         $('.cstm-msg2').show();
  //       }else if ($.inArray(pincode_1, pin_list_3) > -1){
  //         localStorage.setItem('ExistPincode', pincode_1);
  //         localStorage.setItem('storepincode', pincode_1);
  //         $('.pincode-1').attr('placeholder', 'Enter PIN').css('color','#02397f');
  //         if (popup_open == "block"){
  //           setTimeout(function(){$('.popup-pincode').hide();},500);
  //         }
  //         $('.pincode-1').val(pincode_1);
  //         $('.cstm-msg3').show();
  //       }else if ($.inArray(pincode_1, pin_list_4) > -1){
  //         localStorage.setItem('ExistPincode', pincode_1);
  //         localStorage.setItem('storepincode', pincode_1);
  //         $('.pincode-1').attr('placeholder', 'Enter PIN').css('color','#02397f');
  //         if (popup_open == "block"){
  //           setTimeout(function(){$('.popup-pincode').hide();},500);
  //         }
  //         $('.pincode-1').val(pincode_1);
  //         $('.cstm-msg4').show();
  //       }else{
  //         $('.pin-validate-btn span').text("Submit");
  //         localStorage.setItem('ExistPincode', '');
  //         localStorage.setItem('storepincode', '');
  //         localStorage.setItem('PinMsg', '');
  //         $('.cstm-msg').hide();
  //         $('.pin_msg').show();
  //       }
  //     } else {
  //       pin_1.focus().attr('placeholder', 'Invalid PIN').css('color','red'); $('.pincode-1').val('');
  //       localStorage.setItem('PinMsg', '');
  //       $('.pin-validate-btn span').text("Submit");
  //       localStorage.setItem('ExistPincode', '');
  //       localStorage.setItem('storepincode', '');
  //       return false;
  //     }
	  
  //     $('input.pincode-1').keyup(function(event) {
  //       var hide_msg = $(this).val().length;
  //       if(hide_msg < 6) {
  //         $('.cstm-msg, .pin_msg').hide();
  //       }
  //     });

  //     $("input.pincode-1").focus(function(){
  //       $('.cstm-msg, .pin_msg').hide();
  //     });
  //   }); 

  //   // Popup Show or Hide
  //   $('.hdrpin').click(function(evt){$('.popup-pincode').show();});
  //   $('.popup-pincode-inner .close').on('click', function(){
  //     var closePopup = localStorage.setItem("closePop",'true');
  //     $('.popup-pincode').hide();
  //   });
  //   if((closePopup == "true") || (ExistPincode)){
  //     $('.popup-pincode').hide();
  //   }  
  // }
  
  /* Product Tabs */
  $('ul.tabs').each(function(){
    var active, content, links = $(this).find('a');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    links.not(':first').each(function () {
      $($(this).attr('href')).hide();
    });
  
    $(this).find('a').click(function(e){  
      active.removeClass('active');
      content.hide();
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;
    });
  });
  
  /* Open Review Tab when Click on Product Reviews */
  // $(".reviews").click(function(){
  //   setTimeout(function() {
  //     $("#tab-review a").click();
  //   },100);
  // });

  /* Rent or Buy Price */  
  $(".drop-down").on("change", function() {
        var selectedOption = $(this).find("option:selected");
        var optionText = selectedOption.text().trim();
        var rentPrice = selectedOption.attr("sale-price");
        var buyOption = $(this).find('option[dat-title="buy"]').filter(function() {
            return $(this).text().trim() === optionText;
        });
        var rentOption = $(this).find('option[dat-title="rent"]').filter(function() {
            return $(this).text().trim() === optionText;
        });

        if (buyOption.length) {
            var buyPrice = buyOption.attr("sale-price");
            // $(".rent-price .money").text(rentPrice);
            $(".buy-price .buy_ori .money").text(buyPrice);
        }
       if (rentOption.length) {
            var rentPrice1 = rentOption.attr("sale-price");
            $(".rent-price .money").text(rentPrice1);
            // $(".buy-price .buy_ori .money").text(buyPrice);
        }
    });

  /* Disabled Add To Cart Button Till Rental Start Date Selected By User */
  /* On Variant Select */
  $(".drop-down").on("change", function() {
    var selectedOption = $(this).find("option:selected").attr('dat-title');
    var dat = $('#rental').val();
    activeAtc(selectedOption,dat);
  });
  
  /* On Page Load */
  var variant__seleted =  $(".drop-down").find("option:selected").attr('dat-title');
  var productcheck = $('.product-page-info').attr('product-title')
  console.log('variant__seleted_s', productcheck);
  var dat = $('#rental').val();
  if(productcheck == 'rent'){
  activeAtc(variant__seleted,dat);
  }
  /* On Variant Select & Page Load or Referesh */
  function activeAtc(selectedOption,dat) {
    if(selectedOption == 'buy') {
      $('.rent').hide();
      $('.buy').show();
      $('.show-hide').hide();
      $('.product-page-info__button-add-to-cart button, .footbar-product__button-add-to-cart button').css('pointer-events', 'unset');
    }else if(selectedOption == 'adults') {
      $('.rent').hide();
      $('.buy').hide();
      $('.show-hide').hide();
    }else if(selectedOption == 'kids') {
      $('.rent').hide();
      $('.buy').hide();
      $('.show-hide').hide();
    }else {
      $('.rent').show();
      $('.buy').hide();
      $('.show-hide').show();
      if(dat == '') {
        // $('.product-page-info__button-add-to-cart button, .footbar-product__button-add-to-cart button').css('pointer-events', 'none'); 
      }else {
        // $('.product-page-info__button-add-to-cart button, .footbar-product__button-add-to-cart button').css('pointer-events', 'unset'); 
      }
    }
  }
  
  /* On Date Select */
  $('#rental').on('change', function() {
    if($(this).val() !== '') {
      $('.product-page-info__button-add-to-cart button, .footbar-product__button-add-to-cart button').css('pointer-events', 'unset');
      $('.rental-start-date').hide();
    }
  });
  
  /* Delivery Radio Butoon with Message */
  $("#normal").click(function(){
    $(".delivery-txt1").text("Fast Delivery only in Metro & Major Cities");
    $(".delivery-txt2").text("No Delivery & Dispatch on Sundays, Festivals & Holidays");
    $(".remaining_time").hide();
  });
  
  $("#one_two").click(function(){
    $(".delivery-txt1").text("Only Available for Online-Payment Orders");
    $(".delivery-txt2").text("Order Before 5PM, Available in Major Cities");
    $(".remaining_time").show();
  });
});

/* One-Two Day Delivery Time */
(function () {
  var start = new Date();
  var day = start.getDay();
  var hours = start.getHours();
  if(day == 6 && hours > 17) {
    start.setHours(65, 0, 0);
  }else if (day == 0) {
    start.setHours(41, 0, 0);
  }else {
    start.setHours(17, 0, 0);
  }
  function pad(num) {
    return ("0" + parseInt(num)).substr(-2);
  }
  function tick() {
    var now = new Date();
    if (now > start) {
      start.setDate(start.getDate() + 1);
    }
    var remain = (start - now) / 1000;
    var hh = pad((remain / 60 / 60) % 60);
    var mm = pad((remain / 60) % 60);
    var ss = pad(remain % 60);
    jQuery("#timerset").html(hh + ":" + mm + ":" + ss);
    setTimeout(tick, 1000);
  }
  document.addEventListener("DOMContentLoaded", tick);
})();